import { createUnameProfile, type UnameProfile } from "./uname.js";

export class TerminalSession {
    private unameProfile: UnameProfile | null = null;

    getUnameProfile(hostname: string): UnameProfile {
        if (!this.unameProfile) {
            this.unameProfile = createUnameProfile(hostname);
        }
        return this.unameProfile;
    }

    reset(): void {
        this.unameProfile = null;
    }
}
